var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "refresh-change": _vm.refreshChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "search-change": _vm.searchChange,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _vm.permissions.daemon_status_trace_log_del
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-delete" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDel(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("删除\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }